import React, { useContext } from "react";
import { Checkbox } from "../../view/Checkbox";
import { deepCopy } from "../../utils";
import { TableContext, PopupContext } from "../../index";
import { POPUP_TYPES } from "../../view/popup/PopupContainer";
import dots from "../../_resources/img/vdots.png";
import { showSuccessToast, showDangerToast } from "../../validation/ToastContainer";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { CardTypes } from "./ports/PortsCardService";
import Settings from '@mui/icons-material/Settings';
import AddToQueueIcon from '@mui/icons-material/AddToQueue';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { updateOS } from './inventoryService';


function InventoryScanTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const { setPopup } = useContext(PopupContext);

    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })
    }

     //This function is used to convert bigint date to datetimeformat
     const getDateTimeFormat = (bigIntTime) => {
        if (!bigIntTime) {
            return ''
        }
        let datetime = Number(bigIntTime)
        let datetimeformat = 'N/A';
        const dateObject = new Date(datetime)
        datetimeformat = dateObject.toLocaleString()
        return datetimeformat;
    }

    //const { config } = useContext(TableContext);

    const onShowPortsClick = () => {
        const { showModal } = config;
        showModal({ cardType: CardTypes.SHOW, portsList: data.inventoryPorts })
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const confirmEventCreation = async (os) => {       
        updateOS(data.id, os)
            .then((res) => {
                if (!res.os) {
                    showDangerToast("OS edit failed!", "Host OS Edit");
                }
                else {
                    showSuccessToast("OS updated successfully", "Host OS Edit");  

                }
                //let selectedRows = deepCopy(config.selected);
                //setConfig({ ...config, osChanged: res.os })
                window.location.reload();
            });
    };

    const onUpdateOS = () => setPopup(
        {
            type: POPUP_TYPES.UPDATE_OS,
            updatedOS: data.os,
            confirm: confirmEventCreation
        }
    );

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
            </td>
            <td>
                {data.host}
            </td>
            <td>
                {data.status}
            </td>
            <td>
                {data.os}
            </td>
            <td>
                {getDateTimeFormat(data.scanDate)}
            </td>           
            {/* <td>
                <div className="btn oct_btn-tool-table" onClick={() => onShowPortsClick()}>
                    <i className="fas fa-ellipsis-v"></i>
                    <img src={dots} alt="Icon" className="oct_vertical_align" />
                </div>
            </td> */}
             <td>
                <div className="btn oct_btn-tool-table" onClick={handleClick} >
                    <i className="fas fa-ellipsis-v"></i>
                    <img src={dots} alt="Icon" className="oct_vertical_align" />
                </div>


                <Menu
                    id="dots-options"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}>

                    <MenuItem
                        onClick={() => onShowPortsClick()}
                        disabled={false}>
                        <FormatListBulletedIcon></FormatListBulletedIcon>View Ports
                    </MenuItem>

                    <MenuItem
                        onClick={() => onUpdateOS()}
                        disabled={false}>
                        <Settings></Settings> Edit OS
                    </MenuItem>

                    <MenuItem
                        //onClick={ () => { history.push(`/baseline/${data.id}`) }}
                        disabled={true} >
                        <AddToQueueIcon></AddToQueueIcon> Add Device
                    </MenuItem>

                </Menu>

            </td>

            
        </tr>
    )


}

export default InventoryScanTableRow;
